import {install} from 'vue3-recaptcha-v2';

let initialised = false;

export default function () {
    const $config = useRuntimeConfig();
    const nuxtApp = useNuxtApp();

    const init = function () {
        if (initialised) return true;
        nuxtApp.vueApp.use(install, {
            sitekey: $config.public.reCaptchaSiteKey,
            cnDomains: false,
        });
        initialised = true;
        return true;
    };

    return {init};
}
